import { createTheme } from '@mui/material/styles';

let theme = createTheme({
    typography: {
        fontFamily: [
            'Satoshi'
        ].join(',')
    },
    palette: {
        primary: {
            main: '#BA1B1D',
            light: '#BA1B1D',
            dark: '#000000',
        },
        secondary: {
            main: '#333333',
            light: '#381D2A',
            dark:'#4E2A3C'
        },
        background: {
            default: '#FFFFFF',
            paper: '#F5F5F5',
        },
        text: {
            primary: '#333333',
            secondary: '#F7F4F2',
            disabled: '#E9ECEE'
        }
    }
});

theme = createTheme(theme, {
    components: {
        MuiButton: {
            defaultProps: {
                size: 'small'
            },
            styleOverrides: {
                root: {
                    textTransform: 'none',
                }
            },
        },
        MuiTextField: {
            defaultProps: {
                margin: 'dense',
                variant: 'outlined',
                size: 'small',
                fullWidth: true
            },
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '16px'
                    }
                }
            }
        },
        MuiInputLabel: {
            defaultProps: {
                margin: 'dense'
            },
            styleOverrides: {
                root: {
                    color: theme.palette.text.primary,
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: 'normal'
                }
            }
        }
    }
});

export default theme;
